import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

export function ProfileFormSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Profile Settings</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <Skeleton className="h-16 w-16 rounded-full" />
          </div>

          <Separator className="my-4" />

          <div className="grid gap-6 md:grid-cols-2">
            <div className="space-y-2">
              <Label className="text-muted-foreground">Email</Label>
              <Skeleton className="h-10 w-full" />
            </div>

            <div className="space-y-2">
              <Label className="text-muted-foreground">First Name</Label>
              <Skeleton className="h-10 w-full" />
            </div>

            <div className="space-y-2">
              <Label className="text-muted-foreground">Last Name</Label>
              <Skeleton className="h-10 w-full" />
            </div>

            <div className="space-y-2">
              <Label className="text-muted-foreground">Institution Name</Label>
              <Skeleton className="h-10 w-full" />
            </div>
          </div>
        </CardContent>
        <CardFooter className="justify-end">
          <Skeleton className="h-10 w-20" />
        </CardFooter>
      </Card>
    </div>
  );
}
